import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CardConfig} from "@shared/module/card/model";
import {MenuActionType} from "@shared/model";
import {MenuHelperUtils} from "@shared/helper";

@Component({
  selector: 'app-item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.scss']
})
export class ItemListComponent implements OnInit {
  @Input() list!: any[];
  @Input() entity!: string;
  @Input() config!: CardConfig;
  @Input() isLoading: boolean = false;
  @Output() onChoose = new EventEmitter<any>();
  @Output() onActionClick: EventEmitter<{ action: MenuActionType, data: any }> = new EventEmitter<{
    action: MenuActionType,
    data: any
  }>();

  duplicateLoading: boolean = false;
  deleteLoading: boolean = false;
  currentChoose?: any;
  duplicate?: any;
  softDeleted?: any;

  ngOnInit(): void {
    this.duplicate = {
      icon: MenuHelperUtils.DUPLICATE_ICON,
      title: `menu.${this.entity}`,
      type: MenuActionType.DUPLICATE
    };
    this.softDeleted = {
      icon: MenuHelperUtils.DELETE_ICON,
      title: `menu.${this.entity}`,
      type: MenuActionType.SOFTDELETE,
      confirmMessage: {label: `page.${this.entity}.confirm.softdelete.content`},
      titleMessage: {label: `page.${this.entity}.confirm.softdelete.title`}
    };
  }

  onClick(item: any): void {
    this.currentChoose = item;
    this.onChoose.emit(this.currentChoose);
  }

  onClickAction(action: MenuActionType, data: any) {
    this.onActionClick.emit({action, data});
  }
}
